import { useState, type FC } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import VendorChangeTicketDialog from './VendorChangeTicketDialog';

interface MATVendorTicketCellProps {
  data: any;
}

const MATVendorTicketCell: FC<MATVendorTicketCellProps> = ({ data }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const nrmVendorName = data?.['nrm-VendorName'] || '';
  const isDiscovered = !!data?.__isDiscovered__;

  // Only show on discovered rows that have a normalized vendor name
  if (!isDiscovered || !nrmVendorName) return null;

  return (
    <>
      <Tooltip title="Manage vendor change tickets" placement="top">
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setDialogOpen(true);
          }}
          sx={{
            padding: '2px',
            color: 'action.active',
            '&:hover': { color: 'primary.main' },
          }}
          data-cy="vendor-ticket-icon"
        >
          <CorporateFareIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
      <VendorChangeTicketDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        normalizedVendorName={nrmVendorName}
      />
    </>
  );
};

export default MATVendorTicketCell;
